

// ##############################
// Token Utilization by Airlines
// #############################

const setTokenUtilizationData = (data) => {
    let labels = [];
    let tokensBought = [];
    let billablePassengers = [];
    for(let item of data){
        labels.push(item.AirlineName);
        tokensBought.push(item.TokenPurchased);
        billablePassengers.push(item.BillablePassengerCount);
    }

  return {
      labels: labels,
        datasets: [
            {
                label: "Token Purchase",
                fillColor: "rgba(76,175,80,0.8)",
                strokeColor: "rgba(76,175,80,1)",
                pointColor: "rgba(76,175,80,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#4caf50",
                pointHighlightStroke: "rgba(76,175,80,0.9)",
                data: tokensBought
            },
            {
                label: "Billable Passengers",
                fillColor: "rgba(244, 67,54,0.8)",
                strokeColor: "rgba(244, 67,54, 1)",
                pointColor: "rgba(244, 67,54,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#f44336",
                pointHighlightStroke: "rgba(244, 67,54,0.9)",
                data: billablePassengers
            }
        ]
  };
};

const defaultTokenUtilizationData =  {
    labels: ["Aero Air", "Air Peace", "Arik Airways", "Azman Airline", "Dana Air", "Max Air Limited", "Medview", "Overland Airways"],
        datasets: [
        {
            label: "Token Purchased",
            fillColor: "rgba(76,175,80,0.8)",
            strokeColor: "rgba(76,175,80,1)",
            pointColor: "rgba(76,175,80,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#fff",
            pointHighlightStroke: "rgba(220,220,220,1)",
            data: [0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            label: "Billable Passengers",
            fillColor: "rgba(244, 67,54,0.8)",
            strokeColor: "rgba(244, 67,54, 1)",
            pointColor: "rgba(244, 67,54,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#f44336",
            pointHighlightStroke: "rgba(244, 67,54,0.9)",
            data: [0, 0, 0, 0, 0, 0, 0, 0]
        }
    ]
};

const defaultTokenActivityData =  {
     labels : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [
        {
            label: "Token Purchased",
            fillColor: "rgba(76,175,80,0.8)",
            strokeColor: "rgba(76,175,80,1)",
            pointColor: "rgba(76,175,80,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#4caf50",
            pointHighlightStroke: "rgba(76,175,80,0.9)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
            label: "Token Utilized",
            fillColor: "rgba(235,42,35,0.2)",
            strokeColor: "rgba(235,42,35,1)",
            pointColor: "rgba(235,42,35,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#eb2a37",
            pointHighlightStroke: "rgba(235,42,35,1)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
    ]
};
const setTokenActivityData = (data) => {
    let tokenPurchased_ = new Array(12).fill(0);
    let tokenUsed_ = new Array(12).fill(0);
    for(let item of data){
        const index = item.Month;
        tokenPurchased_[index - 1] = item.TokenPurchased;
        tokenUsed_[index - 1] = item.TokenUtilized;
    }
    let labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let tokenPurchasedChartData = {
        labels: labels,
        datasets: [
            {
                label: "Token Purchased",
                fillColor: "rgba(76,175,80,0.8)",
                strokeColor: "rgba(76,175,80,1)",
                pointColor: "rgba(76,175,80,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#4caf50",
                pointHighlightStroke: "rgba(76,175,80,0.9)",
                data: tokenPurchased_
            },
            {
                label: "Token Utilized",
                fillColor: "rgba(235,42,35,0.2)",
                strokeColor: "rgba(235,42,35,1)",
                pointColor: "rgba(235,42,35,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#eb2a37",
                pointHighlightStroke: "rgba(235,42,35,1)",
                data: tokenUsed_
            }
        ]
     };
    let tokenUsedChartData = {
        labels: labels,
        datasets: [
            {
                label: "Token Purchase",
                fillColor: "rgba(255,255,255,0.8)",
                strokeColor: "rgba(255,255,255,,1)",
                pointColor: "rgba(255,255,255,,1)",
                // pointStrokeColor: "#fff",
                // pointHighlightFill: "#4caf50",
                pointHighlightStroke: "rgba(255,255,255,0.9)",
                data: tokenUsed_
            }
        ]
     };
    return {
        tokenPurchasedChartData,
        tokenUsedChartData
    }
};

const defaultAirportTokenUtilizationData =  {
    labels: [],
    datasets: [
        {
            label: "Token Purchased",
            fillColor: "rgba(76,175,80,0.8)",
            strokeColor: "rgba(76,175,80,1)",
            pointColor: "rgba(76,175,80,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#fff",
            pointHighlightStroke: "rgba(220,220,220,1)",
            data: []
        }
    ]
};
const setAirportTokenUtilizationData = (data) =>  {
    let labels = [];
    let chartData = [];
    for(let item of data){
        labels.push(item.AirportCode);
        chartData.push(item.Token);
    }
    return {
        labels: labels, //["MUR", "MIN", "ABJ", "LAG", "JOS"],
        datasets: [
            {
                label: "Token Purchased",
                fillColor: "rgba(76,175,80,0.8)",
                strokeColor: "rgba(76,175,80,1)",
                pointColor: "rgba(76,175,80,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#fff",
                pointHighlightStroke: "rgba(220,220,220,1)",
                data: chartData //[400, 0, 10, 300, 80]
            }
        ]
    }
};

module.exports = {
    defaultTokenUtilizationData,
    setTokenUtilizationData,
    defaultTokenActivityData,
    setTokenActivityData,
    defaultAirportTokenUtilizationData,
    setAirportTokenUtilizationData
};



// WEBPACK FOOTER //
// ./src/variables/charts.jsx